import { NewTabLink } from "../UI/NewTabLink";

export function IsRetSouthend(props: { Campus: string, AcadYearLabel: string }) {
    return <div className="OtherData_Container">
        <fieldset className="OtherData">
            <legend>{props.AcadYearLabel} accommodation applications</legend>

            <h2>Returning {props.Campus} students (undergraduates and postgraduates)</h2>

            <p>Please read all the information on our main Returning Students pages before booking accommodation:</p>

            <p><NewTabLink to="https://www.essex.ac.uk/life/accommodation/apply/returning-students/southend">https://www.essex.ac.uk/life/accommodation/apply/returning-students/southend</NewTabLink>.</p>
        </fieldset>
    </div>;
}